import { useCallback, useState } from "react";
import { getApiErrorMessage } from "../../../lib/result-codes";
import { suspendMerchant as suspendMerchantApi } from "../api/merchant.api";
import type { MerchantDetail } from "../types/merchant.types";

interface UseSuspendMerchantReturn {
  suspendMerchant: (id: string, reason: string) => Promise<MerchantDetail>;
  loading: boolean;
  error: string | null;
}

export const useSuspendMerchant = (): UseSuspendMerchantReturn => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const suspendMerchant = useCallback(
    async (id: string, reason: string): Promise<MerchantDetail> => {
      try {
        setLoading(true);
        setError(null);
        return await suspendMerchantApi(id, { reason });
      } catch (suspendError: unknown) {
        setError(getApiErrorMessage(suspendError, "Failed to suspend merchant"));
        throw suspendError;
      } finally {
        setLoading(false);
      }
    },
    [],
  );

  return { suspendMerchant, loading, error };
};
